export { ProductFeed } from './ProductFeed';
